import React, {Component} from 'react';
import config from 'react-global-configuration';
import {Collapse, Button, Input, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
//import {Card, CardBody, CardText} from 'reactstrap';
import {Card} from 'react-bootstrap';
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {Link} from "react-router-dom";
import axios from "axios";
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import ReactTooltip from 'react-tooltip';
import Select from 'react-select';
import Switch from "react-switch";
import $ from 'jquery';
import CommonNavbar, {navbar} from "./commonNavbar";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import {List} from 'react-virtualized';
import {disable} from "@amcharts/amcharts4/.internal/core/utils/Debug";

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class AdminNewSchemesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: null,
      brand_file_uploaded: [],
      mvalue: {year: new Date().getFullYear(), month: 11},
      _notificationSystem: null,
      timer: null,
      loading: true,
      isSubmit: false,
      file_name: "",
      notify: null,
      activer: [],
      activer_copy: [],
      is_download: false,
      uploadDropdown: false,
      errorModel: false,
      noErrorModel: false,
      file_id_got: null,
      report_file_name: null,
      error_message: null,
      error_message_header: null,
      open_instructions: false,
      emiMenus: [],
      party_options: [
        {value: 'Brand', label: 'Brand'},
        {value: 'Merchant', label: 'Merchant'}
      ],
      party_list: [],
      selected_party_type: null,
      selected_party: null,
      selected_party_type2: null,
      selected_party2: null,
      upload_user_type: null,
      partyTypeID: '',
      partyTypeValue: null,
      partyID: '',
      partyValue: null,
      activer2: [],
      update_disabler: false,
      displaySchemeDiv: "none",
      enableDisablePartyType: 'none',
      canCreateScheme: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.updatePartyValue = this.updatePartyValue.bind(this);
  }

  handleNotificationClick = (position, color, msg) => {
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"/>,
      message: (
        <div>
          {msg}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 5
    });
  };

  componentDidMount() {
    const cancreateScheme = this.canCreateScheme();
    this.setState({
      canCreateScheme: cancreateScheme
    });
    this.setState({_notificationSystem: this.refs.notificationSystem});
    this.fetchPartyList();
    this.setState({
      partyTypeValue: [],
      partyValue: [],
      displaySchemeDiv: 'block',
      enableDisablePartyType: 'block',
    });

    localStorage.setItem('locFlexipay', '0');

    this.getBrandUploadedData();
  }

  fetchPartyList = () => {
    const token = localStorage.usertoken;
    axios.get(config.get('API_URL') + '/brandemi/findAllManufacturers', {
      headers: {
        Authorization: ` ${token}`
      }
    })
      .then(response => {
        console.log(response);
        let party_list = [];
        response.data.map((values, index) => {
          if (values.party_name !== 'Admin') {
            party_list.push({ value: values.id, label: values.party_name });
          }
        });
        this.setState({
          party_list: party_list,
          loading: false
        });
      })
      .catch(error => {
        console.error("Error fetching party list:", error);
        this.setState({ loading: false });
      });
  };

  canCreateScheme = () => {
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    console.log("Decoded user ID:", decoded._id);
    // List of user IDs who can stop promotions
    const allowedUsers = process.env.REACT_APP_ALLOWED_USER;
    console.log("Allowed users:", allowedUsers);
    return allowedUsers.includes(decoded._id);
  }

  updatePartyValue(optionSelected) {
    console.log(optionSelected)
    this.setState({
      loading: true
    })
    let value = '';
    let partyArray = [];
    if (optionSelected.length < 1) {
      value = null;
      partyArray = '';
    } else {
      optionSelected.map((partyids, i) => {
        partyArray.push(partyids.value)
      });
    }
    this.setState({
      partyID: partyArray,
      partyValue: optionSelected,
      uploadDropdown: false,
      loading: false,
    }, () => {
      setTimeout(() => this.getBrandUploadedData(), 0);
      }
    );
  };

  getFileExtension(filename) {
    return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
  }

  openInstructions() {
    this.setState({
      open_instructions: !this.state.open_instructions
    });

  }

  handleChange(checked) {
    console.log(this.state.checked);
    this.setState({
      checked
    });
  }


  getBrandUploadedData() {

    const that = this;
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    var stringCode = decoded.object_code;
    var arrayCode = stringCode.split(",");
    const canCreateScheme = this.canCreateScheme();
    console.log("canCreateScheme value on API Call:", canCreateScheme);
    if ($.fn.DataTable.isDataTable('#userTable')) {
      $('#userTable').DataTable().destroy();
    }

    var vEmiFlexyEndPoint = '';
    var vLocEmiType = localStorage.getItem('locFlexipay');

    if (vLocEmiType === '1') {
      vEmiFlexyEndPoint = "get_new_schemes_master_filter_paginate";
    } else {
      vEmiFlexyEndPoint = "get_new_schemes_master_filter_paginate";
    }

    var data = {
      party_id: this.state.partyID
    }
    var schemeList = $('#schemesViewTable').DataTable(
      {
        order: [],
        "processing": true,
        "serverSide": true,
        "bDestroy": true,
        "paging": true,
        "pageLength": 20,
        "bInfo": true,
        "autoWidth": false,
        "responsive": false,
        "scrollX": true,
        scrollY: "450px",
        scrollCollapse: true,
        searching: true,
        "lengthMenu": [[20, 50, 100, 500 - 1], [20, 50, 100, 500, "All"]],


        ajax: {
          url: config.get('API_URL') + "/brandemi/" + vEmiFlexyEndPoint,
          type: "POST",
          data: data,
          dataSrc: function (json) {
            return json.data;
          },
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", localStorage.usertoken);
          },
        },

        columns: [
          {"data": "party_type"},
          {"data": "party_name"},
          {"data": "scheme_name"},
          {"data": "bank_name"},
          {"data": "brand_cb"},
          {"data": "bank_cb"},
          {"data": "post_brand_cb"},
          {"data": "post_bank_cb"},
          {"data": "low_cost_subvention"},
          {"data": "tid"}, 
          {"data": "record_update_timestamp"},
          {"data": "active"},
          {"data": "editable"},
          {"data": "id"}
        ],
        "columnDefs": [
          {
            "width": "10%",
            render: function (data, type, row) {
              var id = row.id;
                  console.log("Scheme ID:", id, "Scheme Type:", row.scheme_type, "Type of:", typeof row.scheme_type);

              if (row.scheme_type != 'bankemi' && row.scheme_type != 'freeemi') {
                return '<td>' +
                  '<a class="viewButton" data-tip="View Scheme" href="/admin/admin-new-create-schemes-view/' + id + '">' +
                  '<span class="glyphicon glyphicon-eye-open" aria-hidden="true">' +
                  '</span>' +
                  '</a>' +
                  (canCreateScheme ? 
                    '<a class="viewButton" data-tip="Edit Scheme" href="/admin/admin-new-create-schemes-edit/' + id + '">' +
                    '<span class="glyphicon glyphicon-edit" aria-hidden="true">' +
                    '</span>' +
                    '</a>' : ''
                  ) +
                  '<div class="__react_component_tooltip place-bottom type-dark " data-id="tooltip">' +
                  '</div>' +
                  '</td>';
              } else {
                return '<td>' +
                  '<a class="viewButton" data-tip="View Scheme" href="/admin/admin-new-create-schemes-bank-view/' + id + '" currentitem="false">' +
                  '<span class="glyphicon glyphicon-eye-open" aria-hidden="true">' +
                  '</span>' +
                  '</a>' +
                  '<div class="__react_component_tooltip place-bottom type-dark " data-id="tooltip">' +
                  '</div>' +
                  '</td>';
              }
            },
            className: "action_button",
            targets: 13,
            aTargets: [-1]
          },
          {
            "width": "10%",
            render: function (data, type, row) {
              var id = row.id;
              if (row.active == '1' || row.active == 1) {
                return '<td>Yes</td>';
              } else {
                return '<td>No</td>'
              }
            },
            className: "action_button",
            targets: 11,
            aTargets: [-1]
          },
          {
            "width": "10%",
            render: function (data, type, row) {
              if (row.editable == '1' || row.editable == 1) {
                return '<td>No</td>';
              } else {
                return '<td>Yes</td>'
              }
            },
            className: "action_button",
            targets: 12,
            aTargets: [-1]
          },
          {
            //  "width": "5%",
              render: function (data) {
                let timer2 = new Date(data)
                timer2.setHours( timer2.getHours() + 5 );
                timer2.setMinutes( timer2.getMinutes() + 30 );
                // timer
                let timer3 = timer2.toJSON().slice(0, 19).replace('T', ' ');

                return '<td >' + timer3 + '</td>'
              },
              targets: 10,
              aTargets: [-1]
          },
        ]
      });
  }

  downloadCSV = (file_id, file_value) => {
    this.setState({
      is_download: false
    });
    let xhr = $.ajax({
      url: config.get('API_URL') + "/brandemi/download_csv?file_id=" + file_id,
      type: 'GET',
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", localStorage.usertoken);
      },
      xhrFields: {
        responseType: 'blob'
      },
      success: function (response, status, xhr) {
        let blob = new Blob([response], {
          type: "application/csv"
        });
        let fileName = null;
        console.log(file_value);
        console.log(xhr.getResponseHeader('Content-Disposition'));
        if (file_id == '7md38Hhdad3_brand_product_master_template.csv') {
          fileName = 'brand_product_master_template.csv';
        } else {
          fileName = file_value;
        }
        //alert(fileName);
        let rfile = fileName.replace(/\"/g, "");
        // console.log(fileName);
        let a = document.createElement('a');
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = rfile;
        a.click();
        console.log(a);
        window.URL.revokeObjectURL(url);
        this.setState({
          is_download: true
        })
      }.bind(this)
    });
    this.setState({
      xhr: xhr
    })
  };

  downloadReportCSV = (file_id, file_value) => {
    this.setState({
      is_download: false
    });
    let xhr = $.ajax({
      url: config.get('API_URL') + "/brandemi/download_report_csv?file_id=" + file_value,
      type: 'GET',
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", localStorage.usertoken);
      },
      xhrFields: {
        responseType: 'blob'
      },
      success: function (response, status, xhr) {
        let blob = new Blob([response], {
          type: "application/csv"
        });
        let fileName = file_value;
        console.log(file_value);
        console.log(xhr.getResponseHeader('Content-Disposition'));
        //alert(fileName);
        let rfile = fileName.replace(/\"/g, "");
        // console.log(fileName);
        let a = document.createElement('a');
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = rfile;
        a.click();
        console.log(a);
        window.URL.revokeObjectURL(url);
        this.setState({
          is_download: true
        })
      }.bind(this)
    });
    this.setState({
      xhr: xhr
    })
  };

  fileUploadHandler = () => {
    const timer1 = (Date.now()).toString();
    //console.log(timer1);
    this.setState({
      timer: timer1,
      isSubmit: true,
      loading: true
    });
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    // console.log(decoded);
    const data = new FormData();
    data.append('file', this.state.selectedFile);
    data.append('userID', decoded._id);
    data.append('timer', this.state.timer);
    data.append('timer1', timer1);
    // let random_string = Date.now()+'_'+req.body.userID+'_';
    console.log(decoded.userGroup);
    data.append('userGroup', decoded.userGroup);
    data.append('party_master_id', this.state.party_master_id);
    if (this.state.selectedFile == null) {
      this.handleNotificationClick("tr", 3, "Please upload valid file");
      this.setState({
        isSubmit: false,
        loading: false
      });
    } else {
      var file = this.state.selectedFile; //console.log(data);
      var ext = this.getFileExtension(file.name);
      if (ext === 'csv') {
        axios.post(config.get('API_URL') + "/brandemi/new_upload_scheme_master/", data, {
          headers: {
            Authorization: ` ${localStorage.usertoken}`
          }
        })
          .then(res => {
            console.log(res.data);
            this.setState({
              file_id_got: res.data.file_id,
              report_file_name: res.data.report_file_name
            });
            //console.log(res.data.notify);
            //console.log(res.data.inconsistent);
            if (res.data.flag == 2) {
              this.handleNotificationClick("tr", 2, "File with same name uploaded. If you continue, old file will be overwritten.");
            } else if (res.data.flag == 3) {
              this.setState({
                isSubmit: false,
                loading: false,
                notify: res.data.notify,
                file_id_got: res.data.file_id,
                report_file_name: res.data.report_file_name,
                error_message: res.data.total_value + '/' + res.data.total,
                error_message_header: 'Failure'
              });
              this.handleNotificationClick("tr", 3, "No valid data to upload. File not uploaded");

            } else if (res.data.flag == 4) {
              this.handleNotificationClick("tr", 3, "Columns are incorrect in your csv");
            } else if (res.data.success !== undefined && res.data.notify !== undefined && res.data.inconsistent === 0 && res.data.error2 === 0) {
              this.setState({
                isSubmit: false,
                loading: false,
                notify: res.data.notify,
                file_id_got: res.data.file_id,
                report_file_name: res.data.report_file_name,
                error_message: res.data.total_value + '/' + res.data.total
              });
              console.log("call show method on success");
              this.handleNotificationClick("tr", 1, "The file has been uploaded successfully.");
              this.toggleNoErrorModel.bind(this);
              this.setState({
                error_message_header: 'Success'
              })
              this.getBrandUploadedData();
              //this.props.history.push('/admin/brand-product-master')
            } else {
              if (res.data.error2 === 1) {
                this.setState({
                  error_message_header: 'Failure'
                })
                this.getBrandUploadedData();
              } else {
                this.handleNotificationClick("tr", 1, "The file has been uploaded successfully.");
                this.toggleNoErrorModel.bind(this);
                this.setState({
                  error_message_header: 'Success'
                })
                this.getBrandUploadedData();
              }
              this.setState({
                isSubmit: false,
                error_message: res.data.total_value + '/' + res.data.total,
                loading: false,
                notify: res.data.notify,
                file_id_got: res.data.file_id,
                report_file_name: res.data.report_file_name
              });
            }
          })
          .catch(err => {
            console.log(err);// then print response status
            this.handleNotificationClick("tr", 3, "Something Wrong!");
            this.setState({
              isSubmit: false,
              loading: false
            });
            // this.openSectionToMap(true); // remove and place in success block
          })
      } else {
        this.handleNotificationClick("tr", 3, "Please upload valid file");
        this.setState({
          isSubmit: false,
          loading: false
        });
      }
    }
  };

  goBack = () => {
    //this.props.history.push('/admin/brand-emi')
  }

  activeHandler() {
    this.setState({
      isSubmit: true,
      loading: true,
      update_disabler: true
    });
    if (this.state.activer2.length == 0 || this.state.activer2.length == 'undefined') {
      this.handleNotificationClick("tr", 3, "No changes applicable");
      this.setState({
        isSubmit: false,
        loading: false,
        update_disabler: false
      });
    } else {
      const token = localStorage.usertoken;
      const decoded = jwt_decode(token);
      // console.log(decoded);
      const data = new FormData();
      data.append('userID', decoded._id);
      data.append('mappings', JSON.stringify(this.state.activer2));
      data.append('userGroup', decoded.userGroup);
      data.append('party_master_id', this.state.party_master_id);
      axios.post(config.get('API_URL') + "/brandemi/active_updater_scheme", data, {
        headers: {
          Authorization: ` ${localStorage.usertoken}`
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.success) {
            this.handleNotificationClick("tr", 1, 'Record has been updated successfully');
            this.setState({
              isSubmit: false,
              loading: false,
              update_disabler: false
            });
            //this.props.history.push('/admin/brand-product-master')
          } else {
            this.handleNotificationClick("tr", 3, res.data.error);
            this.setState({
              isSubmit: false,
              loading: false,
              update_disabler: false
            });
          }
        })
        .catch(err => { // then print response status
          this.handleNotificationClick("tr", 3, "Something Wrong!");
          this.setState({
            isSubmit: false,
            loading: false,
            update_disabler: false
          })
        })

    }

  };

  changeStatus(id, checked) {
    //let status = 0;
    //if(checked===true){ status = 1 } else { status = 0 }
    this.setState({
      activer2: {...this.state.activer2, [id]: checked},
      activer: {...this.state.activer, [id]: checked}
    })
  }

  uploadDropdownHandler = () => {
    this.setState({
      uploadDropdown: true
    })
  }

  gotoCreateSchemes = () => {
    if(!this.state.canCreateScheme){
      this.handleNotificationClick("tr", 3, "You don't have permission to create scheme.");
      return;
    }
    this.props.history.push('/admin/admin-new-create-schemes-bank');
  }

  toggleErrorModel() {
    this.setState({
      errorModel: !this.state.errorModel
    });
  }

  downloadReport() {
    console.log(this.state.report_file_name);
    this.downloadReportCSV.bind(this, 1, this.state.report_file_name);
  }


  toggleNoErrorModel() {
    this.setState({
      noErrorModel: !this.state.noErrorModel
    });
  }

  gotoUploadedFile = (e) => {
    e.preventDefault();
    let pusher = '/admin/scheme-viewer/' + this.state.file_id_got
    this.props.history.push(pusher)
  }

  _onEmiChecked() {
    this.setState({
      partyTypeValue: [],
      partyValue: [],
      displaySchemeDiv: 'block',
      enableDisablePartyType: 'block'
    });

    localStorage.setItem('locFlexipay', '0');

    this.getBrandUploadedData();
  }

  _onFlexypayChecked() {

    this.setState({
      partyTypeValue: [{value: "Brand", label: "Brand"}],
      partyValue: [{value: 35, label: "Default"}],
      displaySchemeDiv: 'block',
      enableDisablePartyType: 'none'
    })

    localStorage.setItem('locFlexipay', '1');

    this.getBrandUploadedData();
  }

  render() {
    const {canCreateScheme} = this.state;
    const { party_list, partyValue } = this.state;

    console.log('this.state.partyTypeValue');
    console.log(this.state.partyTypeValue);

    console.log('this.state.partyValue');
    console.log(this.state.partyValue);

    const MenuList = props => {
      const rows = props.children;
      let no_of_rows = 0;
      let drop_down_heigth = 0
      if (rows.length !== undefined) {
        no_of_rows = rows.length;
        if (no_of_rows < 9) {
          drop_down_heigth = 40 * no_of_rows;
        } else {
          drop_down_heigth = 300;
        }

      }
      const rowRenderer = ({key, index, isScrolling, isVisible, style}) => (
        <div key={key} style={style}>{rows[index]}</div>
      );

      return (
        <List
          style={{width: '100%'}}
          width={300}
          height={drop_down_heigth}
          rowHeight={30}
          rowCount={no_of_rows}
          rowRenderer={rowRenderer}
        />
      )
    }
    const customStyles = {
      control: provided => ({
        ...provided,
        padding: "0px",
        minHeight: "15px",
      }),
      indicatorsContainer: provided => ({
        ...provided,
        height: "23px"
      }),
      clearIndicator: provided => ({
        ...provided,
        padding: "5px"
      }),
      dropdownIndicator: provided => ({
        ...provided,
        padding: "5px"
      }),
      valueContainer: base => ({
        ...base,
        padding: '0px 6px'
      }),
      menu: styles => ({...styles, zIndex: 999})
    };

    let party_render = this.state.party_options;
    let party_render_list = this.state.party_list;
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    let menus = this.state.emiMenus.map((menu, index) => {
      return (
        <NavItem key={index} eventKey={index + "_" + 5} componentClass={Link} href={menu.layout + menu.path}
                 to={menu.layout + menu.path}>
          {menu.name}
        </NavItem>
      )
    });

    console.log('this.state.enableDisablePartyType');
    console.log(this.state.enableDisablePartyType);

    console.log(this.state.brand_file_uploaded);
    console.log('value.party_name');
    console.log('');

    let brand_file_data = this.state.brand_file_uploaded.map((value, index) => {
      console.log('value.party_name');
      console.log(value.party_name);
      let timer2 = new Date(value.record_update_timestamp)
      timer2.setHours(timer2.getHours() + 5);
      timer2.setMinutes(timer2.getMinutes() + 30);
      // timer
      let timer3 = timer2.toJSON().slice(0, 19).replace('T', ' ');
      let scheme_type = 'Brand EMI';
      if (value.scheme_type == 'exclusiveemi') {
        scheme_type = 'Exclusive EMI';
      } else if (value.scheme_type == 'freeemi') {
        scheme_type = 'Free EMI';
      }

      if (this.state.enableDisablePartyType === 'none' && value.party_name === 'Default') {
        if (value.editable == "1") {
          return (
            <tr key={index + 1}>
              <td>{value.party_type}</td>
              <td>{value.party_name}</td>
              <td>{value.scheme_name}</td>
              <td>{value.bank_name}</td>
              <td>{scheme_type}</td>
              <td>{timer3}</td>
              <td>
                <Switch className="react-switch" height={20} width={38} id={value.id + '_'}
                        onChange={this.changeStatus.bind(this, value.id)}
                        checked={(this.state.activer[value.id]) ? true : false}></Switch>
              </td>
              <td>
                <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                <Link className="viewButton" data-tip="View Scheme"
                      to={"/admin/admin-new-create-schemes-view/" + value.id}><span
                  className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                <Link className="viewButton" data-tip="Edit Scheme"
                      to={"/admin/admin-new-create-schemes-edit/" + value.id}><span className="glyphicon glyphicon-edit"
                                                                                    aria-hidden="true"></span></Link>
              </td>
            </tr>
          )
        } else {
          return (
            <tr key={index + 1}>
              <td>{value.party_type}</td>
              <td>{value.party_name}</td>
              <td>{value.scheme_name}</td>
              <td>{value.bank_name}</td>
              <td>{scheme_type}</td>
              <td>{timer3}</td>
              <td>
                <Switch disabled={true} className="react-switch" height={20} width={38} id={value.id + '_'}
                        onChange={this.changeStatus.bind(this, value.id)}
                        checked={(this.state.activer[value.id]) ? true : false}></Switch>
              </td>
              <td>
                <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                <Link className="viewButton" data-tip="View Scheme"
                      to={"/admin/admin-new-create-schemes-view/" + value.id}><span
                  className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                <Link className="viewButton" data-tip="Unable to edit as scheme in use"><span
                  className="glyphicon glyphicon-edit" aria-hidden="true"></span></Link>
              </td>
            </tr>
          )
        }
      } else if (this.state.enableDisablePartyType === 'block' && value.party_name !== 'Default') {
        if (value.editable == "1") {
          return (
            <tr key={index + 1}>
              <td>{value.party_type}</td>
              <td>{value.party_name}</td>
              <td>{value.scheme_name}</td>
              <td>{value.bank_name}</td>
              <td>{scheme_type}</td>
              <td>{timer3}</td>
              <td>
                <Switch className="react-switch" height={20} width={38} id={value.id + '_'}
                        onChange={this.changeStatus.bind(this, value.id)}
                        checked={(this.state.activer[value.id]) ? true : false}></Switch>
              </td>
              <td>
                <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                <Link className="viewButton" data-tip="View Scheme"
                      to={"/admin/admin-new-create-schemes-view/" + value.id}><span
                  className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                <Link className="viewButton" data-tip="Edit Scheme"
                      to={"/admin/admin-new-create-schemes-edit/" + value.id}><span className="glyphicon glyphicon-edit"
                                                                                    aria-hidden="true"></span></Link>
              </td>
            </tr>
          )
        } else {
          return (
            <tr key={index + 1}>
              <td>{value.party_type}</td>
              <td>{value.party_name}</td>
              <td>{value.scheme_name}</td>
              <td>{value.bank_name}</td>
              <td>{scheme_type}</td>
              <td>{timer3}</td>
              <td>
                <Switch disabled={true} className="react-switch" height={20} width={38} id={value.id + '_'}
                        onChange={this.changeStatus.bind(this, value.id)}
                        checked={(this.state.activer[value.id]) ? true : false}></Switch>
              </td>
              <td>
                <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                <Link className="viewButton" data-tip="View Scheme"
                      to={"/admin/admin-new-create-schemes-view/" + value.id}><span
                  className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                <Link className="viewButton" data-tip="Unable to edit as scheme in use"><span
                  className="glyphicon glyphicon-edit" aria-hidden="true"></span></Link>
              </td>
            </tr>
          )
        }
      }

    });

    let error_message = this.state.error_message;
    let error_message_headere = () => {
      let value_header = this.state.error_message_header;
      if (value_header == 'Failure') {
        return (
          <div className="row">
            <div className="col-md-12">
              <div className="redtexter">{value_header}</div>
            </div>
          </div>
        );
      } else if (value_header == 'Success') {
        return (
          <div className="row">
            <div className="col-md-12">
              <div className="greentexter">{value_header}</div>
            </div>
          </div>
        );
      }
    }

    let link_to_show = () => {
      if (error_message == null) {
        return (<div>
          </div>
        );
      } else {
        if (this.state.error_message_header == 'Failure') {
          return (
            <a href="#" onClick={this.downloadReportCSV.bind(this, 1, this.state.report_file_name)}>View Report</a>
          )
        } else {
          return (
            <a href="#" onClick={this.gotoUploadedFile}>View</a>
          )
        }
      }

    }


    return (
      <div className="longcontent">
        <CommonNavbar/>
        <div className="container-fluid">
          <div className="card" style={{marginBottom: '-2px', paddingLeft: '10px'}}>
            <input type="radio" name="same" onChange={this._onEmiChecked.bind(this)} checked={true}/><small>EMI</small>
            &nbsp; &nbsp; &nbsp;
{/*             <input type="radio" name="same" onChange={this._onFlexypayChecked.bind(this)}/><small>Flexipay</small> */}
          </div>

          {/*style={{display:'none'}}*/}
          <div className="card-query-builder top-pad-5" style={{display: this.state.displaySchemeDiv}}>
            <NotificationSystem ref="notificationSystem" style={style}/>
            <ReactTooltip/>
            <Modal isOpen={this.state.noErrorModel}
                   toggle={this.toggleNoErrorModel.bind(this)}
                   size="lg"
            >
              <ModalBody>
                <div className="row">
                  <div className="col-xs-12 ">
                    <h4 className="modalh4">Product details have been successfully uploaded</h4>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" className="btn-capitalize" onClick={this.gotoUploadedFile.bind(this)}>View
                  Uploaded Schemes</Button>{' '}
              </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.errorModel}
                   toggle={this.toggleErrorModel.bind(this)}
                   size="lg"
            >
              <ModalBody>
                <div className="row">
                  <div className="col-xs-12 ">
                    <h4 className="modalh4">There were errors in your uploaded file</h4>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" className="btn-capitalize" onClick={this.gotoUploadedFile.bind(this)}>View
                  Uploaded Schemes</Button>{' '}
                <Button color="secondary" className="btn-capitalize" onClick={this.downloadReport.bind(this)}>View
                  Report</Button>
              </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.open_instructions}
                   toggle={this.openInstructions.bind(this)}
                   size="lg"
            >
              <ModalHeader>Instructions</ModalHeader>
              <ModalBody>
                <div className="row">
                  <div className="col-md-12">
                    - Keep .csv encoding in UTF-8 format<br/>
                    - Mandatory fields are brand, category, level_1, level_2, sku and mrp<br/>
                    - Keep image url in level_4 (example:
                    https://images-na.ssl-images-amazon.com/images/I/51o5RmQtroL._SL1024_.jpg)
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" className="btn-capitalize"
                        onClick={this.openInstructions.bind(this)}>Close</Button>
              </ModalFooter>
            </Modal>
            <div className="pt-5">
              <div className="card">
                <div className='sweet-loading'>
                  <BeatLoader
                    css={override}
                    sizeUnit={"px"}
                    size={20}
                    color={'#123abc'}
                    loading={this.state.loading}
                  />
                </div>
                <div className="header">

                  <h4 className="title pull-left">Schemes</h4>
                  <button onClick={this.gotoCreateSchemes} className="btn btn-primary btn-capitalize pull-right">Create
                    new scheme
                  </button>

                </div>

                <div className="content">
                  <div className="row top-margin-30">
                    <div className="col-md-3">
                      <Label>Select party</Label>
                      <ReactMultiSelectCheckboxes
                          name="party_name_filter"
                          components={{MenuList}}
                          value={partyValue}
                          styles={customStyles}
                          className="report-listbox"
                          onChange={this.updatePartyValue.bind(this)}
                          options={party_list}
                          placeholderButtonLabel="Select [Party Name]"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="container-fluid">
                      <div className="table-full-width table-responsive-bemi notablerightmargin top-pad-5">
                        <table className="table table-striped table-hover" id="schemesViewTable">
                          <thead>
                          <tr>
                            <th>Party Type</th>
                            <th>Party Name</th>
                            <th>Scheme Name</th>
                            <th>Bank Name</th>
                            <th>Upfront Cashback Brand</th>
                            <th>Upfront Cashback Bank</th>
                            <th>Post Cashback Brand</th>
                            <th>Post Cashback Bank</th>
                            <th>Low Cost Subvension</th>
                            <th>TID</th> 
                            <th>Time stamp</th>
                            <th>Active</th>
                            <th>In use?</th>
                            <th>Action</th>
                          </tr>
                          </thead>
                          <tbody>
                          {brand_file_data}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  {/* <div className="row">
                                <div className ="col-md-12">
                                <button onClick={this.activeHandler.bind(this)} disabled={this.state.update_disabler} className="btn btn-primary btn-capitalize pull-right">Update</button>
                                </div>
                            </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminNewSchemesList;